<script setup lang="ts">
import QrImage from '@/assets/qr1.png'
import { useIsSp } from '@mp/hooks'
import { ElPopover } from 'element-plus'

const { isNotSp, name, beian } = useIsSp()
</script>

<template>
  <div v-if="isNotSp" class="text-center text-xs bg-[#666] text-[#999] p-4 line-height-6">
    <p>{{ name }}</p>
    <p><a href="https://beian.miit.gov.cn/" target="_blank" class="hover:text-white">{{ beian }}</a></p>
  </div>
  <div v-else class="text-center text-xs bg-[#666] text-[#999] p-4 line-height-6">
    <p>客服支持：400-720-8888 人工服务：9:00-22:00 自助服务：7x24小时</p>
    <p>
      <a href="https://news.shengpay.com/aboutus" target="_blank" class="text-gray-400 hover:text-primary">关于盛付通</a> 丨
      <a href="https://www.shengpay.com/" target="_blank" class="text-gray-400 hover:text-primary">盛付通官网</a> 丨
      <a
        href="https://news.shengpay.com/aboutus/contacts" target="_blank"
        class="text-gray-400 hover:text-primary"
      >联系我们</a> 丨

      <ElPopover placement="top" :width="180">
        <div class=" text-center text-xs text-gray-400 py-4">
          <img :src="QrImage" class=" block mx-auto" alt="">
          <p class="mt-3 mb-0">
            搜索“盛付通运营”或
          </p>
          <p class="m-0">
            扫描上方二维码
          </p>
        </div>
        <template #reference>
          <a href="javascript:;" class="text-gray-400 hover:text-primary">
            微信服务号
          </a>
        </template>
      </ElPopover>
    </p>
    <p>上海盛付通电子支付服务有限公司 版权所有</p>
    <p>
      <a
        href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502001963" target="_blank"
        class="text-inherit underline hover:text-primary"
      >沪公网备31011502001963号</a> <a
        href="https://beian.miit.gov.cn/" target="_blank"
        class="text-inherit underline hover:text-primary"
      >沪ICP备08024653号-10</a>
    </p>
  </div>
</template>
